export const tell = test => {
	return String(test).replace(/(\d{3})\d*(\d{4})/, "$1****$2");
}

export const formatDate = (time, type = 1) => {
    let date = new Date(time);
    let YY = date.getFullYear();
    let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
	if(type === 0) {
		if(uni.getSystemInfoSync().platform === 'android'){
			return `${YY}-${MM}-${DD}`;
		}else{
			return `${YY}/${MM}/${DD}`;
		}
	}else {
		let hh = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
		let mm = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
		let ss = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
		if(uni.getSystemInfoSync().platform === 'android'){
			return `${YY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
		}else{
			return `${YY}/${MM}/${DD} ${hh}:${mm}:${ss}`;
		}
	}
}

export const formatRichText = html => {
  let newContent= html.replace(/<img[^>]*>/gi, (match,capture) => {
    match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
    match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
    match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
    return match;
  });
  newContent = newContent.replace(/style="[^"]+"/gi, (match,capture) => {
    match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
    return match;
  });
  newContent = newContent.replace(/<br[^>]*\/>/gi, '');
  newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"');
  return newContent;
}

export const queryNode = (callback, node = ".lg_container") => {
	let query = uni.createSelectorQuery();
	query.select(node).boundingClientRect(data => {
		let result;
		if(data) result = data;
		else result = {};
		callback && callback(result);
	}).exec();
}

export const Debounce = (fn, t) => {
	const delay = t || 300;
	let timer;
	return function() {
		const args = arguments;
		if (timer) {
			clearTimeout(timer)
		}
		timer = setTimeout(() => {
			timer = null;
			fn.apply(this, args);
		}, delay)
	}
}

export const jia = (arg1, arg2) => {
  let r1, r2, m;
  try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 };
  try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 };
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}

export const jian = (arg2, arg1) => {
  let r1, r2, m, n;
  try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2));
  //lastmodifybydeeka  
  //动态控制精度长度  
  n = (r1 >= r2) ? r1 : r2;
  return ((arg2 * m - arg1 * m) / m).toFixed(n);
}

export const cheng = (arg1, arg2) => {
  let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try { m += s1.split(".")[1].length } catch (e) { }
  try { m += s2.split(".")[1].length } catch (e) { }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

export const chu = (arg1, arg2) => {
  let t1 = 0, t2 = 0, r1, r2;
  try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
  try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
  r1 = Number(arg1.toString().replace(".", ""))
  r2 = Number(arg2.toString().replace(".", ""))
  return (r1 / r2) * Math.pow(10, t2 - t1);
}